import { ComponentType, createContext, ReactNode } from "react";
import { Helmet } from "react-helmet";

interface ChildrenProps {
  chilren: ReactNode;
}

export const GoogleAnalyticsContext = createContext<any>(null);

const GoogleAnalyticsProvider: ComponentType<ChildrenProps> = ({
  children,
}) => {
  return (
    <GoogleAnalyticsContext.Provider value={{}}>
      {(window.location.host === "matanotktanot.netinatlulav.com" ||
        window.location.host === "www.matanotktanot.netinatlulav.com") && (
        <Helmet>
          {/* Reg Google Analytics (connected to Ayal's Google account) */}
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=UA-177471745-1"
          ></script>
          <script>
            {`window.dataLayer = window.dataLayer || [];
				function gtag() {dataLayer.push(arguments); }
				gtag('js', new Date());
				gtag('config', 'UA-177471745-1');`}
          </script>

          {/* Global site tag (gtag.js) - Google Ads: 591110975 */}
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=AW-591110975"
          ></script>
          <script>
            {`window.dataLayer = window.dataLayer || [];
  				function gtag(){dataLayer.push(arguments);}
  				gtag('js', new Date());

  				gtag('config', 'AW-591110975');`}
          </script>

          {/* Faceabook pixel other */}

          <script>
            {`!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod ?
				n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '432475371126727');
				fbq('track', 'PageView');`}
          </script>
          {/* Facebook Pixel Code */}
          <script>
            {`!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '346223693232800');
				fbq('track', 'PageView');`}
          </script>

          {/* Google Tag Manager */}
          <script>
            {`(function(w,d,s,l,i)
				{w[l] = w[l] || [];
				w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
				var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
				j.async=true;
				j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
				f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer','GTM-KCQ58RC');`}
          </script>
          <noscript>
            {`<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KCQ58RC" height="0" width="0" style={{ display: 'none', visibility: 'hidden' }}></iframe>`}
          </noscript>
        </Helmet>
      )}

      {children}
    </GoogleAnalyticsContext.Provider>
  );
};

export default GoogleAnalyticsProvider;
